(() => {
  const ALLOWED_VARIANTS = new Set([
    '58036890239311', // DAILY Essential
    '58084626006351', // DAILY Skin
    '58164199227727', // DAILY D3 • K2 • Mg
    '58283149918543'  // DAILY Ritual Set
  ]);

  const OPEN_CART_KEY = 'quiz_open_cart';


  /**
   * Öffnet den vorhandenen Sidecart des Themes,
   * indem exakt der normale Warenkorb-Button ausgelöst wird.
   */
  function openCartDrawer() {
    let attempts = 0;
    const maxAttempts = 20;

    const timer = setInterval(() => {
      const cartTriggers = Array.from(
        document.querySelectorAll(
          'a[aria-controls="CartDrawer"][aria-label="Warenkorb"]'
        )
      );

      // Wenn Desktop + Mobile vorhanden sind:
      // möglichst den aktuell sichtbaren Button verwenden.
      const cartTrigger =
        cartTriggers.find(element => element.offsetParent !== null) ||
        cartTriggers[0];

      if (!cartTrigger) {
        attempts++;

        if (attempts >= maxAttempts) {
          clearInterval(timer);
          console.warn('Quiz: Warenkorb-Button wurde nicht gefunden.');
        }

        return;
      }

      clearInterval(timer);

      // Falls der Drawer bereits offen ist, nichts machen.
      if (cartTrigger.getAttribute('aria-expanded') === 'true') {
        return;
      }

      /*
       * Wir benutzen den normalen Theme-Button.
       * Navigation auf /cart wird vorsichtshalber verhindert,
       * ohne die übrigen Click-Handler des Themes zu blockieren.
       */
      const preventCartNavigation = event => {
        event.preventDefault();
      };

      cartTrigger.addEventListener(
        'click',
        preventCartNavigation,
        {
          once: true,
          capture: true
        }
      );

      cartTrigger.click();
    }, 250);
  }


  document.addEventListener('DOMContentLoaded', async () => {

    /**
     * 1. Nach dem Reload:
     * Sidecart öffnen, wenn das Produkt vorher über das Quiz
     * hinzugefügt wurde.
     */
    if (sessionStorage.getItem(OPEN_CART_KEY) === '1') {
      sessionStorage.removeItem(OPEN_CART_KEY);

      // Theme kurz vollständig initialisieren lassen
      setTimeout(() => {
        openCartDrawer();
      }, 700);
    }


    /**
     * 2. Prüfen, ob Produkte über ?quiz_add= übergeben wurden.
     */
    const url = new URL(window.location.href);
    const quizAdd = url.searchParams.get('quiz_add');

    if (!quizAdd) {
      return;
    }


    /**
     * 3. IDs auslesen und nur erlaubte Produkte akzeptieren.
     */
    const variantIds = [
      ...new Set(
        quizAdd
          .split(',')
          .map(id => id.trim())
          .filter(id => ALLOWED_VARIANTS.has(id))
      )
    ];

    if (!variantIds.length) {
      console.warn('Quiz: Keine gültigen Produktvarianten gefunden.');
      return;
    }


    /**
     * 4. Produkte in den Shopify-Warenkorb legen.
     */
    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          items: variantIds.map(id => ({
            id: Number(id),
            quantity: 1
          }))
        })
      });


      if (!response.ok) {
        throw new Error(
          `Produkte konnten nicht hinzugefügt werden. Status: ${response.status}`
        );
      }


      /**
       * 5. quiz_add aus der URL entfernen.
       *
       * Wichtig:
       * Sonst würden die Produkte beim Reload erneut
       * hinzugefügt werden.
       */
      url.searchParams.delete('quiz_add');


      /**
       * 6. Merken, dass nach dem Reload
       * der Sidecart geöffnet werden soll.
       */
      sessionStorage.setItem(OPEN_CART_KEY, '1');


      /**
       * 7. Seite neu laden.
       *
       * Dadurch aktualisiert das Theme selbst:
       * - Warenkorb
       * - Cart Count
       * - Cart Drawer
       *
       * Wir manipulieren diese Werte nicht selbst.
       */
      window.location.replace(
        url.pathname + url.search + url.hash
      );


    } catch (error) {
      console.error('Quiz Cart Error:', error);
    }
  });
})();